import { Note } from '../../notes/notes.models';
import { AppState } from '../../reducers';

const notesSelector = (state: AppState) => state.connectWise.notes;

export const connectWiseNoteSelector = (state: AppState): Note[] => notesSelector(state).notes;
